import { str, bool, date, FieldMap } from '../acordFieldEngine';


export const OTHER_MAP: FieldMap = {
  insurerLtr:     str('OtherPolicy_InsurerLetterCode_A'),
  type:           str('OtherPolicy_OtherPolicyDescription_A'),
  policyNumber:   str('OtherPolicy_PolicyNumberIdentifier_A'),
  effDate:        date('OtherPolicy_EffectiveDate_A'),
  expDate:        date('OtherPolicy_ExpirationDate_A'),
  limits:         str('OtherPolicy_CoverageLimitAmount_A'),
  limitCode:      str('OtherPolicy_CoverageCode_A'),
  deductibleCode: str('OtherPolicy_CoverageCode_B'),
  deductibleAmt:  str('OtherPolicy_CoverageLimitAmount_B'),
  limitCode3:     str('OtherPolicy_CoverageCode_C'),
  limitAmt3:      str('OtherPolicy_CoverageLimitAmount_C'),
};

export const CGL_MAP: FieldMap = {
  insurerLtr:      str('GeneralLiability_InsurerLetterCode_A'),
  policyNumber:    str('Policy_GeneralLiability_PolicyNumberIdentifier_A'),
  effDate:         date('Policy_GeneralLiability_EffectiveDate_A'),
  expDate:         date('Policy_GeneralLiability_ExpirationDate_A'),
  claimsMade:      bool('GeneralLiability_ClaimsMadeIndicator_A'),
  occur:           bool('GeneralLiability_OccurrenceIndicator_A'),
  blank1Check:     bool('GeneralLiability_OtherCoverageIndicator_A'),
  blank1Text:      str('GeneralLiability_OtherCoverageDescription_A'),
  blank2Check:     bool('GeneralLiability_OtherCoverageIndicator_B'),
  blank2Text:      str('GeneralLiability_OtherCoverageDescription_B'),
  policy:          bool('GeneralLiability_GeneralAggregate_LimitAppliesPerPolicyIndicator_A'),
  project:         bool('GeneralLiability_GeneralAggregate_LimitAppliesPerProjectIndicator_A'),
  loc:             bool('GeneralLiability_GeneralAggregate_LimitAppliesPerLocationIndicator_A'),
  otherAgg:        bool('GeneralLiability_GeneralAggregate_LimitAppliesToOtherIndicator_A'),
  otherAggText:    str('GeneralLiability_GeneralAggregate_LimitAppliesToCode_A'),
  eachOccurrence:  str('GeneralLiability_EachOccurrence_LimitAmount_A'),
  damageRented:    str('GeneralLiability_FireDamageRentedPremises_EachOccurrenceLimitAmount_A'),
  medExp:          str('GeneralLiability_MedicalExpense_EachPersonLimitAmount_A'),
  personalAdv:     str('GeneralLiability_PersonalAndAdvertisingInjury_LimitAmount_A'),
  generalAgg:      str('GeneralLiability_GeneralAggregate_LimitAmount_A'),
  productsAgg:     str('GeneralLiability_ProductsAndCompletedOperations_AggregateLimitAmount_A'),
  blankLimitLabel: str('GeneralLiability_OtherCoverageLimitDescription_A'),
  blankLimitAmt:   str('GeneralLiability_OtherCoverageLimitAmount_A'),
};

export const AUTO_MAP: FieldMap = {
  insurerLtr:      str('Vehicle_InsurerLetterCode_A'),
  policyNumber:    str('Policy_AutomobileLiability_PolicyNumberIdentifier_A'),
  effDate:         date('Policy_AutomobileLiability_EffectiveDate_A'),
  expDate:         date('Policy_AutomobileLiability_ExpirationDate_A'),
  anyAuto:         bool('Vehicle_AnyAutoIndicator_A'),
  allOwned:        bool('Vehicle_AllOwnedAutosIndicator_A'),
  scheduled:       bool('Vehicle_ScheduledAutosIndicator_A'),
  hired:           bool('Vehicle_HiredAutosIndicator_A'),
  nonOwned:        bool('Vehicle_NonOwnedAutosIndicator_A'),
  blank1Check:     bool('Vehicle_OtherCoveredAutoIndicator_A'),
  blank1Text:      str('Vehicle_OtherCoveredAutoDescription_A'),
  blank2Check:     bool('Vehicle_OtherCoveredAutoIndicator_B'),
  blank2Text:      str('Vehicle_OtherCoveredAutoDescription_B'),
  combinedSingle:  str('Vehicle_CombinedSingleLimit_EachAccidentAmount_A'),
  bodilyPerson:    str('Vehicle_BodilyInjury_PerPersonLimitAmount_A'),
  bodilyAccident:  str('Vehicle_BodilyInjury_PerAccidentLimitAmount_A'),
  propertyDamage:  str('Vehicle_PropertyDamage_PerAccidentLimitAmount_A'),
  blankLimitLabel: str('Vehicle_OtherCoverage_CoverageDescription_A'),
  blankLimitAmt:   str('Vehicle_OtherCoverage_LimitAmount_A'),
};

export const UMBRELLA_MAP: FieldMap = {
  insurerLtr:      str('ExcessUmbrella_InsurerLetterCode_A'),
  policyNumber:    str('Policy_ExcessLiability_PolicyNumberIdentifier_A'),
  effDate:         date('Policy_ExcessLiability_EffectiveDate_A'),
  expDate:         date('Policy_ExcessLiability_ExpirationDate_A'),
  umbrellaLiab:    bool('Policy_PolicyType_UmbrellaIndicator_A'),
  excessLiab:      bool('Policy_PolicyType_ExcessIndicator_A'),
  occur:           bool('ExcessUmbrella_OccurrenceIndicator_A'),
  claimsMade:      bool('ExcessUmbrella_ClaimsMadeIndicator_A'),
  ded:             bool('ExcessUmbrella_DeductibleIndicator_A'),
  retentionCheck:  bool('ExcessUmbrella_RetentionIndicator_A'),
  retention:       str('ExcessUmbrella_Umbrella_DeductibleOrRetentionAmount_A'),
  eachOccurrence:  str('ExcessUmbrella_Umbrella_EachOccurrenceAmount_A'),
  aggregate:       str('ExcessUmbrella_Umbrella_AggregateAmount_A'),
  blankLimitLabel: str('ExcessUmbrella_OtherCoverageDescription_A'),
  blankLimitAmt:   str('ExcessUmbrella_OtherCoverageLimitAmount_A'),
};

export const WC_MAP: FieldMap = {
  insurerLtr:        str('WorkersCompensationEmployersLiability_InsurerLetterCode_A'),
  policyNumber:      str('Policy_WorkersCompensationAndEmployersLiability_PolicyNumberIdentifier_A'),
  effDate:           date('Policy_WorkersCompensationAndEmployersLiability_EffectiveDate_A'),
  expDate:           date('Policy_WorkersCompensationAndEmployersLiability_ExpirationDate_A'),
  perStatute:        bool('WorkersCompensationEmployersLiability_WorkersCompensationStatutoryLimitIndicator_A'),
  other:             bool('WorkersCompensationEmployersLiability_OtherCoverageIndicator_A'),
  otherText:         str('WorkersCompensationEmployersLiability_OtherCoverageDescription_A'),
  specialProvisions: str('WorkersCompensationEmployersLiability_AnyPersonsExcludedIndicator_A'),
  eachAccident:      str('WorkersCompensationEmployersLiability_EmployersLiability_EachAccidentLimitAmount_A'),
  diseaseEmployee:   str('WorkersCompensationEmployersLiability_EmployersLiability_DiseaseEachEmployeeLimitAmount_A'),
  diseasePolicyLimit:str('WorkersCompensationEmployersLiability_EmployersLiability_DiseasePolicyLimitAmount_A'),
};
